import React, { useContext, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { LanguageContext } from "../../context/LanguageContext";
import "./Contact.css";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const { language } = useContext(LanguageContext);
  const captchaRef = useRef(null);

  const [isVerified, setIsVerified] = useState(false);
  const [status, setStatus] = useState(""); // success / error / ""
  const [captchaError, setCaptchaError] = useState(false); // To show reCAPTCHA error
  const [errorMessage, setErrorMessage] = useState("");

    // Regex patterns
  const nameRegex = /^[a-zA-Z\u0600-\u06FF\s]{2,40}$/;
  const subjectRegex = /^.{3,100}$/;
  const messageRegex = /^.{5,1000}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Simple sanitization to strip HTML tags
  const sanitize = (str) => str.replace(/<\/?[^>]+(>|$)/g, "");

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;

    const name = sanitize(form.name.value.trim());
    const email = sanitize(form.email.value.trim());
    const subject = sanitize(form.subject.value.trim());
    const message = sanitize(form.message.value.trim());

        // 1. Empty field check
    if (!name || !email || !subject || !message) {
      setStatus("error");
      setErrorMessage(language === "ar" ? "رجاءً املأ جميع الحقول." : "Please fill in all fields.");
      return;
    }

      // 2. Pattern validation
    if (!nameRegex.test(name)) {
      setStatus("error");
      setErrorMessage(language === "ar" ? "الاسم غير صالح." : "Invalid name.");
      return;
    }
    if (!emailRegex.test(email)) {
      setStatus("error");
      setErrorMessage(language === "ar" ? "البريد الإلكتروني غير صالح." : "Invalid email.");
      return;
    }
    if (!subjectRegex.test(subject)) {
      setStatus("error");
      setErrorMessage(language === "ar" ? "الموضوع غير صالح." : "Invalid subject.");
      return;
    }
    if (!messageRegex.test(message)) {
      setStatus("error");
      setErrorMessage(language === "ar" ? "الرسالة قصيرة جدًا أو طويلة جدًا." : "Message too short or too long.");
      return;
    }

     // 3. reCAPTCHA check
    if (!isVerified) {
      setStatus("error");
      setErrorMessage(language === "ar" ? "رجاءً أكد أنك لست روبوتًا." : "Please verify you're not a robot.");
      return;
    }

    // Send email using EmailJS
    emailjs.send("service_gidh0ud", "template_ju1yc1i", {
      name,
      email,
      subject,
      message,
    },  "hIejAdh_PD4c8afDk"
  )
   .then(
      () => {
        setStatus("success");
        setCaptchaError(false);
        captchaRef.current.reset();
        setIsVerified(false);
        form.reset();
          setTimeout(() => {
            setStatus("");
            }, 4000);
      },
      (error) => {
        console.error(error);
        setStatus("error");
        setTimeout(() => {
          setStatus("");
        }, 4000);

      }
    );
};

  return (
    <div className="contact-container" dir={language === "ar" ? "rtl" : "ltr"} id="contact">
      <div className="fade-transition" key={language}>
        <h2 className="contact-title">
          {language === "ar" ? "تواصل معنا" : "Contact Us"}
        </h2>
        <p className="contact-subtitle">
          {language === "ar" ? "لا تتردد في التواصل معنا." : "Don’t hesitate to contact us."}
        </p>

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="row">
            <input type="text" name="name" placeholder={language === "ar" ? "الاسم الكامل" : "Full name"} required />
            <input type="email" name="email" placeholder={language === "ar" ? "البريد الإلكتروني" : "Your e-mail"} required />
          </div>
          <input type="text" name="subject" placeholder={language === "ar" ? "الموضوع" : "Subject"} required />
          <textarea name="message" placeholder={language === "ar" ? "الرسالة" : "Message"} rows="5" required />

          {/* reCAPTCHA section */}
          <div className="captcha-container">
            <ReCAPTCHA
              sitekey="6Le70IEaAAAAABO1zqqn_OafvbGhJbnjPN8fsPuA"
              onChange={() => {
                setIsVerified(true);
                setCaptchaError(false);
              }}
              ref={captchaRef}
            />
          </div>

          <button type="submit">
            {language === "ar" ? "إرسال" : "Send"}
          </button>
                
          {/* Messages for user feedback */}

          {status === "success" && (
              <p className="form-success-message">
                   {language === "ar" ? "تم الإرسال بنجاح!" : "Message sent successfully!"}
                     </p>
                )}
                
                 {status === "error" && (
                  <p className="form-error-message">{errorMessage}</p>
                  )}

                 {captchaError && (
                  <p className="captcha-error-message">
                    {language === "ar" ? "رجاءً أكد أنك لست روبوتًا" : "Please verify you're not a robot"}
                     </p>
                    )}

                     {captchaError && (
                       <p className="captcha-error-message">
                         {language === "ar" ? "رجاءً أكد أنك لست روبوتًا" : "Please verify you're not a robot"}
                           </p>
                           )}
                     </form>
                           
        <div className="map-container">
          <iframe
          title="Falcom Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28991.70831269172!2d46.688714719097355!3d24.728131986099076!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f1d4c87bd9583%3A0xe603d4a12c9664f5!2sYaqeen%20Capital!5e0!3m2!1sar!2ssa!4v1751446349450!5m2!1sar!2ssa"
          width="100%"
          height="400"
          style={{ border: 0, borderRadius: "12px" }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade">

         </iframe>
        </div>

        <div className="contact-info-box">
          <h3 className="contact-info-title">
            {language === "ar" ? "معلومات التواصل" : "Contact Information"}
            </h3>
            <ul className="contact-info-list">
              
              <li>
                <i className="fas fa-envelope"></i>
                <a href="mailto:info@falcomholding.com.sa">info@falcomholding.com.sa</a>
                </li>

              <li>
                <i className="fas fa-map-marker-alt"></i>
                {language === "ar"
                ? "ص.ب ٨٨٤ الرياض ١١٤٢١، المملكة العربية السعودية"
                : "P.O. Box 884 Riyadh 11421, Kingdom of Saudi Arabia"}
             </li>
             
             <li>
             <i className="fas fa-building"></i>
              {language === "ar"
              ? "مبنى يقين، شارع العليا مع طريق الملك عبد الله، الرياض"
              : "Yaqeen Building, Olaya Street with King Abdullah Street, Riyadh, KSA"}
             </li>
            </ul>
           </div>
            </div>
         </div>
         );
        };

export default Contact;
